import { QueryClient } from "@tanstack/react-query";

/**
 * React Query Client Configuration
 *
 * Performance optimizations:
 * - staleTime: How long data is considered "fresh" (no refetch)
 * - gcTime: How long unused/inactive cache entries are kept in memory
 * - Disabled automatic refetching to reduce unnecessary API calls
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      retry: false,
    },
    queries: {
      retry: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutes - data considered fresh
      gcTime: 1000 * 60 * 10, // 10 minutes - unused cache kept in memory
    },
  },
});
